import { NgModule, Injector } from '@angular/core';
import { ImportMaterialModule } from '../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { createCustomElement } from '@angular/elements';
import { InputString } from './input.string';
import { CommonModule } from '@angular/common';
import { InputChips } from './input.chips';
import { InputSelect } from './input.select';
import { InputBoolean } from './input.boolean';
import { InputNumber } from './input.number';
import { InputDate } from './input.date';
import { InputTime } from './input.time';
import { SmartList } from './list';
import { ImportPrimeModule } from '../prime.module';
import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';
import { InputMenu } from './input.menu';
import { LookupMenuItem } from './lookup.menu';
import { LookupTree } from './lookup.tree';
import { AnimatedTree } from './anim.tree';
import { ToolsModule } from '../tools/tools.module';
import { SearchableTree } from './search.tree';

@NgModule({
  declarations: [
    InputString, InputNumber, InputChips, InputSelect, InputBoolean, InputDate, InputTime,
    InputMenu, LookupMenuItem, LookupTree,
    AnimatedTree, SearchableTree, SmartList,
  ],
  imports: [
    CommonModule,
      // BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      ImportMaterialModule,
      ImportPrimeModule,
      NgxBootstrapSliderModule,
      ToolsModule,
      ImportMaterialModule,
  ],
  exports: [
      InputString, InputNumber, InputChips, InputSelect, InputBoolean, InputDate, InputTime,
      InputMenu, LookupMenuItem, LookupTree,
      AnimatedTree, SearchableTree, SmartList,
  ],
  entryComponents: [
      LookupMenuItem
  ],
  providers: [
  ]
})
export class ControlModule {

  constructor(private injector: Injector) {
    // const eform = createCustomElement(EForm, {injector: this.injector});

    // customElements.define('ess-eform', eform as any);
    // console.log("Registered element (with distinct selector!!!!!!) " + "ess-eform");

  }  
}